import React from 'react';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { translate } from 'react-i18next';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import muiThemeable from 'material-ui/styles/muiThemeable';

class OfferStandsList extends React.Component {

  calculatePercentageDiscount = (product) => {
    return Math.round((product.price - product.discountPrice) * 100 / product.price);
  }

  calculateEuroDiscount = (product) => {
    return Number((product.price - product.discountPrice)).toFixed(2);
  }

  render()  {
    const {t} = this.props;

    const flashStyle = this.props.flash ? {
      textAlign: 'right',
      backgroundColor: this.props.muiTheme.palette.primary1Color
    } : {
      textAlign: 'right',
      transition: 'background-color 0.5s linear',
      MozTransition: 'background-color 0.5s linear',
      WebkitTransition: 'background-color 0.5s linear',
      MsTransition: 'background-color 0.5s linear'
    };

    const headerColumnStyle = {
      color: this.props.muiTheme.palette.accent3Color
    };

    const headerColumnNumberStyle = {
      textAlign: 'center',
      color: this.props.muiTheme.palette.accent3Color
    };

    const currentStands =
    this.props.currentStands.map((stand) => (
      <Card key={stand.key}>
        <CardHeader
          title={stand.name}
        />
        <CardText>
          <Table style={{tableLayout: 'auto'}}>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn style={headerColumnStyle}>{t('product.product')}</TableRowColumn>
                <TableRowColumn style={headerColumnNumberStyle} >{t('price')}</TableRowColumn>
                <TableRowColumn style={headerColumnNumberStyle} >{t('offer.discount')}</TableRowColumn>
                <TableRowColumn style={headerColumnNumberStyle} >{t('offer.reducedPrice')}</TableRowColumn>
              </TableRow>
              {stand.currentProducts.map((product) => (
                <TableRow key={product.key + product.standKey}>
                  <TableRowColumn style={{whiteSpace: 'normal', wordWrap: 'break-word'}}>
                    {product.name}
                  </TableRowColumn>
                  <TableRowColumn style={{textAlign: 'right'}}>
                    {Number(product.price).toFixed(2) + ' €'}
                  </TableRowColumn>
                  <TableRowColumn  style={{textAlign: 'right'}}>
                    {this.calculatePercentageDiscount(product) + ' % '
                    + '(' + this.calculateEuroDiscount(product) + ' €)'}
                  </TableRowColumn>
                  <TableRowColumn style={flashStyle}>
                    {Number(product.discountPrice).toFixed(2) + ' €'}
                  </TableRowColumn>
                </TableRow>))}
            </TableBody>
          </Table>
        </CardText>
      </Card>

    ));

    return (
      <Card className='cardStyle'>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle text={t('offer.offerStands')} />
          </ToolbarGroup>
        </Toolbar>
        {currentStands}
        <LoadingIndicator display={this.props.loadingIndicator} />
      </Card>
    );
  }

}

const enhance = compose(muiThemeable(),translate(), firebase, user);

export default enhance(OfferStandsList);



// WEBPACK FOOTER //
// ./src/Offer/OfferStandsList.js